import {RouterProvider} from 'react-router-dom';
import {Toaster} from 'sonner';
import {router} from '@/router';

export default function App() {
  return (
    <div className="min-h-screen w-full bg-primary-dark">
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'hsl(168 47% 6%)',
            border: '1px solid hsl(168 10% 18%)',
            color: 'hsl(150 16% 80%)'
          }
        }}
      />
    </div>
  );
}
